import ApplicationSerializer from 'lumen/serializers/application';

export default class AggregatedUserSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'users') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      return super['modelNameFromPayloadKey']('aggregated-users');
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super['modelNameFromPayloadKey'](key);
  }
}
